export default __webpack_public_path__ + "static/media/aleth.12d34362.svg";